import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManger from '@/Management/ComponentManager';

export default class DummyLayoutViewModel extends ControlViewModel {

    /**
     * Die Factory-Tuples
     */
    public tuples: Array<any>;

    /**
     * Beinhaltet und verändert die Breite der LabelColumn
     */
    public labelColumnWidth: KnockoutObservable<number | string>;

    /**
     * Das ViewModel für die DummyLayout
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.tuples = this.paramOrDefault(params.tuples, []);
        this.labelColumnWidth = this.observableOrDefault(params.labelColumnWidth, 200);
    }
}

ComponentManger.setViewModel('DummyLayoutViewModel', DummyLayoutViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');